export enum ProductSize {
    HARDCOVER = "HARDCOVER",
    PAPERBACK = "PAPERBACK",
 
}

export enum ProductVolume {
    HALF = 0.5,
    ONE = 1,
    ONE_POINT_TWO = 1.2,
    ONE_POINT_FIVE = 1.5,
    TWO = 2,
}

export enum ProductStatus {
    PAUSE = "PAUSE",
    PROCESS = "PROCESS",
    DELETE = "DELETE",
}

export enum ProductCollection {
    RELIGIOUS = "RELIGIOUS",
    PERSONAL = "PERSONAL",
    BUSINES = "BUSINES",
    FOR_CHILDREN = "FOR_CHILDREN",
    FICTION_BOOKS = "FICTION_BOOKS",
}
